<template>
  <div class="none__rtl lock__rtl">
    <v-layout class="mt-20 rev_you_app_private_wrap bg_type3" column>
      <v-flex>
        <v-row class="rev_you_app_private bg_type3 ma-0">
          <v-col class="left_cont">
            <p>Arab Republic of Egypt</p>
            <p></p>
            <p>Egyptian Intellectual Property Authority</p>
            <p class="desc_title">PATENT OFFICE</p>
          </v-col>
          <v-col class="compect_col d-flex logo_c">
            <img width="126" height="58" src="~@/assets/img/logo_auth.png"/>
          </v-col>
          <v-col class="text-right right_cont">
            <p>جمهورية مصر العربية</p>
            <p></p>
            <p>الجهاز المصري للملكية الفكرية</p>
            <p class="desc_title">مكتب براءات الاختراع</p>
          </v-col>
        </v-row>
      </v-flex>
      <v-flex class="middle_cont st2" column>
        <p>
          طلب براءة اختراع أو نموذج منفعة
          <br>
          Application for a Patent or Utility Certificare
        </p>

        <div class="d_flex">
          <span>Utillty model</span>
          <div class="input_checkbox_type_basic">
            <v-checkbox
              v-model="utility_chk"
              readonly
              hide-details
            ></v-checkbox>
          </div>
          <span>نموذج منفعة</span>
          <v-spacer class="hidden_lr20"></v-spacer>
          <span>Patent</span>
          <div class="input_checkbox_type_basic">
            <v-checkbox
              v-model="patent_chk"
              readonly
              hide-details
            ></v-checkbox>
          </div>
          <span>براءة اختراع</span>
        </div>

      </v-flex>
      <v-flex class="end_cont">
        <v-row class="ma-0">
          <v-col class="item_boxs">
            <p>Application No. / رقم الطلب :  </p>
            <h2>{{ filing.application_no }}</h2>
            <p>Int. application No.(PCT) الرقم الدولى:</p>
            <h2>{{ filing.international_application_no ? filing.international_application_no : '' }}</h2>
          </v-col>
          <v-col class="item_boxs">
            <p>filing Date. / تاريخ التقديم :</p>
            <h2>{{ filing.filing_date }}</h2>
            <p>Int. filing Date(PCT) تاريخ التقديم الدولى:</p>
            <h2>{{ filing.international_filing_date ? filing.international_filing_date : '' }}</h2>
          </v-col>
          <v-col class="item_boxs">
            <p>Time / الوقت:</p>
            <h2>{{ filing.filing_time }}</h2>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>

    <div class="table__wrap">
      <!-- TITLE OF INVENTION -->
      <v-row class="bd-ddd ma-0">
        <v-col cols="12">
          <h2 class="nec_title">(1) TITLE OF INVENTION</h2>
          <div class="input_text_type_basic mt--5">
            <v-text-field
              dense
              outlined
              hide-details
              readonly
              v-model="filing.title_en"
              class="ft-size12"
            >
            </v-text-field>
          </div>
        </v-col>
        <v-col cols="12">
          <h2 class="nec_title text-right">(1) مسمى الاختراع</h2>
          <div class="input_text_type_basic mt--5">
            <v-text-field
              dense
              outlined
              hide-details
              readonly
              v-model="filing.title_ar"
              class="ft-size12 text-right"
            >
            </v-text-field>
          </div>
        </v-col>
      </v-row>

      <!-- APPLICANT(S) -->
      <v-row>
        <v-col cols="12" class="pb-0">
          <h2 class="nec_title type2 small">(2) APPLICANT(S) مقدم الطلب  </h2>
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-row class="posr ma-0">
            <v-col cols="3" class="bd-ddd posa-r">
              <h2 class="nec_title">Telephone No. / رقم التليفون</h2>
              <v-spacer class="hidden_lr5"></v-spacer>
              <p style="font-size: 12px; font-weight: normal;">
                {{ applicant_first.telephone }}
              </p>
            </v-col>
            <v-col cols="9" class="bd-ddd bd-b0">
              <h2 class="nec_title">Name</h2>
              <div class="input_text_type_basic mt--5">
                <v-text-field
                  dense
                  outlined
                  hide-details
                  readonly
                  class="ft-size12"
                  v-model="applicant_first.name_en"
                >
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="9" class="bd-ddd">
              <h2 class="nec_title text-right">الاسم</h2>
              <div class="input_text_type_basic mt--5">
                <v-text-field
                  dense
                  outlined
                  hide-details
                  readonly
                  class="ft-size12 text-right"
                  v-model="applicant_first.name_ar"
                >
                </v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-row class="posr ma-0">
            <v-col cols="3" class="bd-ddd bd-t0 posa-r">
              <h2 class="nec_title">Facsimile No. / رقم الفاكس</h2>
              <v-spacer class="hidden_lr5"></v-spacer>
              <p style="font-size: 12px; font-weight: normal;">
                {{ applicant_first.fax }}
              </p>
            </v-col>
            <v-col cols="9" class="bd-ddd bd-t0 bd-b0">
              <h2 class="nec_title">
                Nationality
                <div class="input_text_type_basic mt--5">
                  <v-select
                    hide-details
                    :items="countryEnList"
                    v-model="applicant_first.nationality_code"
                    outlined
                    dense
                    readonly
                    class="ft-size12"
                  ></v-select>
                </div>
              </h2>
              <div class="d-flex align-center">
                <v-checkbox
                  class="ft-size12"
                  hide-details
                  readonly
                  label="Company"
                  :input-value="'Company' == fnParseApplicantTypeCode(applicant_first.applicant_type_code)"
                ></v-checkbox>
                <v-spacer class="hidden_lr5"></v-spacer>
                <v-checkbox
                  class="ft-size12"
                  hide-details
                  readonly
                  :input-value="'Individual' == fnParseApplicantTypeCode(applicant_first.applicant_type_code)"
                  label="Individual"
                ></v-checkbox>
                <v-spacer class="hidden_lr5"></v-spacer>
                <v-checkbox
                  class="ft-size12"
                  hide-details
                  readonly
                  :input-value="'Research' == fnParseApplicantTypeCode(applicant_first.applicant_type_code)"
                  label="Research Institute"
                ></v-checkbox>
              </div>
            </v-col>
            <v-col cols="9" class="bd-ddd text-right">
              <h2 class="nec_title">
                الجنسية
                <div class="input_text_type_basic mt--5">
                  <v-select
                    hide-details
                    :items="countryArList"
                    v-model="applicant_first.nationality_code"
                    outlined
                    dense
                    readonly
                    class="ft-size12"
                  ></v-select>
                </div>
              </h2>
              <div class="d-flex align-center">
                <v-checkbox
                  class="ft-size12"
                  hide-details
                  readonly
                  :input-value="'Company' == fnParseApplicantTypeCode(applicant_first.applicant_type_code)"
                  label="شركة"
                ></v-checkbox>
                <v-spacer class="hidden_lr5"></v-spacer>
                <v-checkbox
                  class="ft-size12"
                  hide-details
                  readonly
                  :input-value="'Individual' == fnParseApplicantTypeCode(applicant_first.applicant_type_code)"
                  label="فرد"
                ></v-checkbox>
                <v-spacer class="hidden_lr5"></v-spacer>
                <v-checkbox
                  class="ft-size12"
                  hide-details
                  readonly
                  :input-value="'Research' == fnParseApplicantTypeCode(applicant_first.applicant_type_code)"
                  label="جهة بحثية"
                ></v-checkbox>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-row class="posr ma-0">
            <v-col cols="3" class="bd-ddd bd-t0 posa-r">
              <h2 class="nec_title">E-mail address / البريد الالكترونى</h2>
              <v-spacer class="hidden_lr5"></v-spacer>
              <p style="font-size: 12px; font-weight: normal;">
                {{ applicant_first.email }}
              </p>
            </v-col>
            <v-col cols="9" class="bd-ddd bd-b0 bd-t0">
              <h2 class="nec_title">Resident Address</h2>
              <v-row>
                <v-col>
                  <label class="nec_title">Country : </label>
                  <div class="input_text_type_basic mt--5">
                    <v-select
                      hide-details
                      :items="countryEnList"
                      v-model="applicant_first.residence_country_code"
                      outlined
                      dense
                      readonly
                      class="ft-size12"
                    ></v-select>
                  </div>
                </v-col>
                <v-col>
                  <label class="nec_title">City : </label>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                </v-row>
              <v-row>
                <v-col>
                  <label class="nec_title">Address : </label>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                      v-model="applicant_first.address_en"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <label class="nec_title">P.O. Box : </label>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                      v-model="applicant_first.pobox_en"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="9" class="bd-ddd">
              <h2 class="nec_title text-right">العنوان البريدى</h2>
              <v-row class="rtl">
                <v-col>
                  <label class="nec_title">الدولة : </label>
                  <div class="input_text_type_basic mt--5">
                    <v-select
                      hide-details
                      :items="countryArList"
                      v-model="applicant_first.residence_country_code"
                      outlined
                      dense
                      readonly
                      class="ft-size12"
                    ></v-select>
                  </div>
                </v-col>
                <v-col>
                  <label class="nec_title">المدينة : </label>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row class="rtl">
                <v-col>
                  <label class="nec_title">العنوان : </label>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                      v-model="applicant_first.address_ar"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row class="rtl">
                <v-col>
                  <label class="nec_title">ص . ب : </label>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                      v-model="applicant_first.pobox_ar"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="bd-ddd ma-0 bd-b0 bd-t0">
        <v-col>
          <h2 class="nec_title">State (that is, country) of nationality: دولة الجنسية</h2>
          <div class="input_text_type_basic mt--5">
            <v-select
              hide-details
              :items="countryList"
              v-model="applicant_first.nationality_code"
              outlined
              dense
              readonly
              class="ft-size12"
            ></v-select>
          </div>
        </v-col>
        <v-col class="bd-ddd bd-t0 bd-b0">
          <h2 class="nec_title">State (that is, country) of residence: دولة الإقامة</h2>
          <div class="input_text_type_basic mt--5">
            <v-select
              hide-details
              :items="countryList"
              v-model="applicant_first.residence_country_code"
              outlined
              dense
              readonly
              class="ft-size12"
            ></v-select>
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0 bd-ddd">
        <v-col cols="12">
          <v-checkbox
            dense
            hide-details
            readonly
            :input-value="applicants.length > 1"
            label="Further applicants are indicated on the following sheet: Continuation of Box No.(2) فى حالة وجود أكثر من مقدم طلب يملأ النموذج المرفق" class="mt-0 ft-size12"
          ></v-checkbox>
        </v-col>
      </v-row>
    </div>

    <!-- INVENTOR(S) -->
    <v-row>
      <v-col cols="12" class="pb-0">
        <h2 class="nec_title type2 small">(3) INVENTOR(S) المخترعون</h2>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="12" class="bd-ddd bd-b0">
        <v-checkbox
          dense
          hide-details
          readonly
          label="The applicant(s) indicated in Box No.(2) is(are) the sole inventor(s) (if this check-box is marked, do not fill in the rest of Box No.(3))"
          class="mt-0 ft-size12"
          :input-value="inventor_first.applicant_seq"
        ></v-checkbox>
        <h2 class="nec_title text-right mt--5">(فى حالة ما إذا كان مقدم الطلب هو المخترع يتم تعليم الصندوق ولاتملأ البيانات فى البند رقم (3)</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row class="posr ma-0">
          <v-col cols="3" class="bd-ddd posa-r">
            <h2 class="nec_title">Telephone No. / رقم التليفون</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;">
              {{ inventor_first.telephone }}
            </p>
          </v-col>
          <v-col cols="9" class="bd-ddd bd-b0">
            <h2 class="nec_title">Name</h2>
            <div class="input_text_type_basic mt--5">
              <v-text-field
                dense
                outlined
                hide-details
                readonly
                class="ft-size12"
                v-model="inventor_first.name_en"
              >
              </v-text-field>
            </div>
          </v-col>
          <v-col cols="9" class="bd-ddd">
            <h2 class="nec_title text-right">الاسم</h2>
            <div class="input_text_type_basic mt--5">
              <v-text-field
                dense
                outlined
                hide-details
                readonly
                v-model="inventor_first.name_ar"
                class="ft-size12 text-right"
              >
              </v-text-field>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row class="posr ma-0">
          <v-col cols="3" class="bd-ddd bd-t0 posa-r">
            <h2 class="nec_title">Facsimile No. / رقم الفاكس</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;">
              {{ inventor_first.fax }}
            </p>
          </v-col>
          <v-col cols="9" class="bd-ddd bd-t0 bd-b0">
            <h2 class="nec_title">
              Nationality
              <div class="input_text_type_basic mt--5">
                <v-select
                  hide-details
                  :items="countryEnList"
                  v-model="inventor_first.nationality_code"
                  outlined
                  dense
                  readonly
                  class="ft-size12"
                ></v-select>
              </div>
            </h2>

          </v-col>
          <v-col cols="9" class="bd-ddd text-right">
            <h2 class="nec_title">
              الجنسية
              <div class="input_text_type_basic mt--5">
                <v-select
                  hide-details
                  :items="countryArList"
                  v-model="inventor_first.nationality_code"
                  outlined
                  dense
                  readonly
                  class="ft-size12"
                ></v-select>
              </div>
            </h2>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row class="posr ma-0">
          <v-col cols="3" class="bd-ddd bd-t0 posa-r">
            <h2 class="nec_title">E-mail address / البريد الالكترونى</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;">
              {{ inventor_first.email }}
            </p>
          </v-col>
          <v-col cols="9" class="bd-ddd bd-b0 bd-t0">
            <h2 class="nec_title">Resident Address</h2>
            <v-row>
              <v-col>
                <label class="nec_title">Country : </label>
                <div class="input_text_type_basic mt--5">
                  <v-select
                    hide-details
                    :items="countryEnList"
                    v-model="inventor_first.residence_country_code"
                    outlined
                    dense
                    readonly
                    class="ft-size12"
                  ></v-select>
                </div>
              </v-col>
              <v-col>
                <label class="nec_title">City : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <label class="nec_title">Address : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="inventor_first.address_en"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <label class="nec_title">P.O. Box : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="inventor_first.pobox_en"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="9" class="bd-ddd">
            <h2 class="nec_title text-right">العنوان البريدى</h2>
            <v-row class="rtl">
              <v-col>
                <label class="nec_title">الدولة : </label>
                <div class="input_text_type_basic mt--5">
                  <v-select
                    hide-details
                    :items="countryArList"
                    v-model="inventor_first.residence_country_code"
                    outlined
                    dense
                    readonly
                    class="ft-size12"
                  ></v-select>
                </div>
              </v-col>
              <v-col>
                <label class="nec_title">المدينة : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row class="rtl">
              <v-col>
                <label class="nec_title">العنوان : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="inventor_first.address_ar"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row class="rtl">
              <v-col>
                <label class="nec_title">ص . ب : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="inventor_first.pobox_ar"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ma-0 bd-ddd bd-t0">
      <v-col cols="12">
        <v-checkbox
          dense
          hide-details
          readonly
          :input-value="inventors.length > 1"
          label="Further applicants are indicated on the following sheet: Continuation of Box No.(2) فى حالة وجود أكثر من مقدم طلب يملأ النموذج المرفق" class="mt-0 ft-size12"
        ></v-checkbox>
      </v-col>
    </v-row>

    <!-- REPRESENTATIVE -->
    <v-row>
      <v-col cols="12" class="pb-0">
        <h2 class="nec_title type2 small">(4) REPRESENTATIVE:  The person identified below is hereby/has been appointed to act on behalf of the applicant(s)<br/>before the Office as a representative     (بيانات الوكيل)    الشخص التالى أسمه تم تعينه من قبل مقدم / مقدمى الطلب لتمثيل / تمثيلهم  أمام المكتب
        </h2>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row class="posr ma-0">
          <v-col cols="3" class="bd-ddd bd-b0 posa-r">
            <h2 class="nec_title">Telephone No. / رقم التليفون</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;">
              {{ representative_first.telephone }}
            </p>
          </v-col>
          <v-col cols="9" class="bd-ddd bd-b0">
            <h2 class="nec_title">Name</h2>
            <div class="input_text_type_basic mt--5">
              <v-text-field
                dense
                outlined
                hide-details
                readonly
                class="ft-size12"
                v-model="representative_first.name_en"
              >
              </v-text-field>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row class="posr ma-0">
          <v-col cols="3" class="bd-ddd posa-r">
            <h2 class="nec_title">Facsimile No. / رقم الفاكس</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;">
              {{ representative_first.fax }}
            </p>
          </v-col>
          <v-col cols="9" class="bd-ddd">
            <h2 class="nec_title text-right">الاسم</h2>
            <div class="input_text_type_basic mt--5">
              <v-text-field
                dense
                outlined
                hide-details
                readonly
                class="ft-size12 text-right"
                v-model="representative_first.name_ar"
              >
              </v-text-field>
            </div>
          </v-col>

        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-row class="posr ma-0">
          <v-col cols="3" class="bd-ddd bd-t0 bd-b0 posa-r">
            <h2 class="nec_title">E-mail address / البريد الالكترونى</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;">
              {{ representative_first.email }}
            </p>
          </v-col>
          <v-col cols="9" class="bd-ddd bd-t0 bd-b0">
            <h2 class="nec_title">Address</h2>
            <v-row>
              <v-col>
                <label class="nec_title">Country : </label>
                <div class="input_text_type_basic mt--5">
                  <v-select
                    hide-details
                    :items="countryEnList"
                    v-model="representative_first.nationality_code"
                    outlined
                    dense
                    readonly
                    class="ft-size12"
                  ></v-select>
                </div>
              </v-col>
              <v-col>
                <label class="nec_title">City : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <label class="nec_title">Address : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="representative_first.address_en"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <label class="nec_title">P.O. Box : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="representative_first.pobox_en"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="posr ma-0">
          <v-col cols="3" class="bd-ddd posa-r">
            <h2 class="nec_title">Registration No. رقم التسجيل</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;">
              {{ representative_first.agent_no }}
            </p>
          </v-col>
          <v-col cols="9" class="bd-ddd">
            <h2 class="nec_title text-right">العنوان البريدى</h2>
            <v-row class="rtl">
              <v-col>
                <label class="nec_title">الدولة : </label>
                <div class="input_text_type_basic mt--5">
                  <v-select
                    hide-details
                    :items="countryArList"
                    v-model="representative_first.nationality_code"
                    outlined
                    dense
                    readonly
                    class="ft-size12"
                  ></v-select>
                </div>
              </v-col>
              <v-col>
                <label class="nec_title">المدينة : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row class="rtl">
              <v-col>
                <label class="nec_title">العنوان : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="representative_first.address_ar"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row class="rtl">
              <v-col>
                <label class="nec_title">ص . ب : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="representative_first.pobox_ar"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="ma-0 bd-ddd bd-t0">
          <v-col cols="12">
            <v-checkbox
              dense
              hide-details
              readonly
              label="The person above represents all applicants./ المذكور أعلاه يمثل كل المقدمين"
              class="mt-0 ft-size12"
              :input-value="representative_first.rep_scope_type_code == '5101'"
            ></v-checkbox>
            <v-checkbox
              dense
              hide-details
              readonly
              label="If not, specify the applicant(s) who is(are) represented by the person above:/ لو غير ذلك يذكر أسم مقدم الطلب الذى يمثله المذكور أعلاه" class="mt-0 ft-size12"
              :input-value="representative_first.rep_scope_type_code == '5102'"
            ></v-checkbox>
            <span class="pl-30" v-if="representative_first.applicants.length > 0">
              <template v-for="(applicant, index) in representative_first.applicants">
                <span v-if="index > 0" :key="'rf_comma'+ index">, </span>
                <span class="ft-size12" :key="'rf_name'+ index">{{applicant.name_ar}}</span>
              </template>
            </span>
          </v-col>
        </v-row>
        <v-row class="ma-0 bd-ddd bd-t0">
          <v-col cols="12">
            <v-checkbox
              dense
              hide-details
              readonly
              label="The power of attorney is attachedمرفق التوكيل"
              class="mt-0 ft-size12"
              :input-value="JSON.stringify(representative_first.poa_upload_type_codes).indexOf('5201') > -1"
            ></v-checkbox>
            <v-checkbox
              dense
              hide-details
              readonly
              label="The appointment is made in this request Formالتعيين طبقا للطلب المرفق"
              class="mt-0 ft-size12"
              :input-value="JSON.stringify(representative_first.poa_upload_type_codes).indexOf('5202') > -1"
            ></v-checkbox>
            <v-checkbox
              dense
              hide-details
              readonly
              :label="'The power of attorney (No. '+ (JSON.stringify(representative_first.poa_upload_type_codes).indexOf('5203') > -1 ? representative_first.poa_reference_app_no : '.....................') +')    is already in the possession of the Office. التوكيل موجود بالمكتب'"
              class="mt-0 ft-size12"
              :input-value="JSON.stringify(representative_first.poa_upload_type_codes).indexOf('5203') > -1"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row class="ma-0 bd-ddd bd-t0">
          <v-col cols="12">
            <v-checkbox
              dense
              hide-details
              readonly
              label="Further representatives are indicated on the following sheet: Continuation of Box No. IVفى حالة وجود أكثر من وكيل يرفق صورة من النموذج"
              class="mt-0 ft-size12"
              :input-value="representatives.length > 1"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- CORRESPONDENCE -->
    <v-row>
      <v-col cols="12" class="pb-0 pt-0">
        <h2 class="nec_title type2 small">(5) ADDRESS FOR CORRESPONDENCE OR LEGAL SERVICE عنوان المراسلة</h2>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row class="posr ma-0">
          <v-col cols="3" class="bd-ddd bd-b0 posa-r">
            <h2 class="nec_title">Telephone No. / رقم التليفون</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;">
              {{ representative_first.telephone }}
            </p>
          </v-col>
          <v-col cols="9" class="bd-ddd bd-b0">
            <h2 class="nec_title">Name</h2>
            <div class="input_text_type_basic mt--5">
              <v-text-field
                dense
                outlined
                hide-details
                readonly
                class="ft-size12"
                v-model="representative_first.name_en"
              >
              </v-text-field>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row class="posr ma-0">
          <v-col cols="3" class="bd-ddd posa-r">
            <h2 class="nec_title">Facsimile No. / رقم الفاكس</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;">
              {{ representative_first.fax }}
            </p>
          </v-col>
          <v-col cols="9" class="bd-ddd">
            <h2 class="nec_title text-right">الاسم</h2>
            <div class="input_text_type_basic mt--5">
              <v-text-field
                dense
                outlined
                hide-details
                readonly
                class="ft-size12 text-right"
                v-model="representative_first.name_ar"
              >
              </v-text-field>
            </div>
          </v-col>

        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-row class="posr ma-0">
          <v-col cols="3" class="bd-ddd bd-t0 posa-r">
            <h2 class="nec_title">E-mail address / البريد الالكترونى</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;">
              {{ representative_first.email }}
            </p>
          </v-col>
          <v-col cols="9" class="bd-ddd bd-t0 bd-b0">
            <h2 class="nec_title">Address</h2>
            <v-row>
              <v-col>
                <label class="nec_title">Country : </label>
                <div class="input_text_type_basic mt--5">
                  <v-select
                    hide-details
                    :items="countryEnList"
                    v-model="representative_first.nationality_code"
                    outlined
                    dense
                    readonly
                    class="ft-size12"
                  ></v-select>
                </div>
              </v-col>
              <v-col>
                <label class="nec_title">City : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <label class="nec_title">Address : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="representative_first.address_en"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <label class="nec_title">P.O. Box : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="representative_first.pobox_en"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="9" class="bd-ddd">
            <h2 class="nec_title text-right">العنوان البريدى</h2>
            <v-row class="rtl">
              <v-col>
                <label class="nec_title">الدولة : </label>
                <div class="input_text_type_basic mt--5">
                  <v-select
                    hide-details
                    :items="countryArList"
                    v-model="representative_first.nationality_code"
                    outlined
                    dense
                    readonly
                    class="ft-size12"
                  ></v-select>
                </div>
              </v-col>
              <v-col>
                <label class="nec_title">المدينة : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row class="rtl">
              <v-col>
                <label class="nec_title">العنوان : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="representative_first.address_ar"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row class="rtl">
              <v-col>
                <label class="nec_title">ص . ب : </label>
                <div class="input_text_type_basic mt--5">
                  <v-text-field
                    dense
                    outlined
                    hide-details
                    readonly
                    class="ft-size12"
                    v-model="representative_first.pobox_ar"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>


    <!-- ----------------------------------------------------------------------------------------------------------------------------- -->

    <!-- APPLICATION FOR A PATENT OF DIVISIBLE APPLICATION OTHERWISE ASSOCIATED WITH ONE OR MORE OTHER APPLICATIONS -->
    <v-row>
      <v-col cols="12" class="pb-0 pt-0">
        <h2 class="nec_title type2 small">(6) APPLICATION FOR A PATENT OF DIVISIBLE  APPLICATION OTHERWISE ASSOCIATED WITH ONE OR MORE OTHER APPLICATIONS إذا كان الطلب عن براءة أو نموذج منفعه منسلخ    </h2>
      </v-col>
      <v-col cols="12" class="pb-0 pt-0">
        <v-row class="ma-0 posr">
          <v-col cols="8" md="8" sm="12" class="bd-ddd" style="min-height:300px;">
            <h2 class="nec_title">The present application is: الطلب يمثل </h2>
            <v-checkbox
              class="ft-size12"
              hide-details
              readonly
              label="An application for a patent of divisible application طلب براءة منسلخ "
              v-model="filing.orginal_application.ind_divisional_patent"
              value="Y"
            ></v-checkbox>
            <v-checkbox
              class="ft-size12"
              hide-details
              readonly
              label="an application for a utility model of divisible application طلب نموذج منفعة منسلخ"
              v-model="filing.orginal_application.ind_divisional_um"
              value="Y"
            ></v-checkbox>
            <v-checkbox
              class="ft-size12"
              hide-details
              readonly
              label="an application by new applicant(s) determined by the competent authority to 	be entitled to an invention contained in an earlier application طلب منسلخ بمقدمين جدد من صاحب الطلب الاصلى أو من يمثل"
              v-model="filing.orginal_application.ind_earlier_app"
              value="Y"
            ></v-checkbox>
          </v-col>
          <v-col cols="4" md="4" sm="12" class="posa-r bd-ddd" style="height:50%;">
            <h2 class="nec_title">Filing date of the other application, or of the application for the other patent, associated with the present application:تاريخ الطلب أوالبراءة السابقة</h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;" v-if="this.filing.orginal_application.ind_divisional_app === 'Y' || this.filing.orginal_application.ind_earlier_app === 'Y'">
              {{ filing.orginal_application.filing_date }}
            </p>
          </v-col>
          <v-col cols="4" md="4" sm="12" class="posa-r bd-ddd bd-t0" style="top:50%; height:50%;">
            <h2 class="nec_title">Application or patent number of the other application or patent:رقم الطلب أو البراءة </h2>
            <v-spacer class="hidden_lr5"></v-spacer>
            <p style="font-size: 12px; font-weight: normal;" v-if="this.filing.orginal_application.ind_divisional_app === 'Y' || this.filing.orginal_application.ind_earlier_app === 'Y'">
              {{ filing.orginal_application.application_no }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- PRIORITY CLAIM -->
    <div>
      <v-row>
        <v-col cols="12" class="pb-0">
          <h2 class="nec_title type2 small">(7) PRIORITY CLAIM:  The priority of the following earlier application(s) is hereby claimed / الأسبقيات</h2>
        </v-col>
        <v-col cols="12" class="pb-0 pt-0">
          <div class="table__inner__table">
            <table>
              <tr>
                <td rowspan="2">
                  Filing date
                  of earlier application
                  (day/month/year)
                  تاريخ تقديم الطلب

                </td>
                <td rowspan="2">
                  Number
                  of earlier application
                  رقم الطلب
                </td>
                <td colspan="3">
                  Where earlier application is:الطلب السابق هو
                </td>
              </tr>
              <tr>
                <td>
                  National application: country party to the Paris Convention or Member of WTO طلب وطنى لدولة عضو فى إتفاقية باريس أو منظمة التجارة العالمية
                </td>
                <td>
                  Regional application:* regional Office طلب إقليمى بمكتب إقليمى
                </td>
                <td>
                  International application: receiving Office طلب دولى بمكتب تلقى الطلبات الدولية
                </td>
              </tr>
              <template v-for="(item, index) in priorities">
                <tr :key="index">
                  <td class="text-left">({{ index+1 }})&nbsp;{{ parseDateFormat(item.priority_date) }}</td>
                  <td>
                    <div class="input_text_type_basic tb">
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        readonly
                        class="ft-size12"
                        :value="item.priority_no"
                      >
                      </v-text-field>
                    </div>
                  </td>
                  <td>
                    <div class="input_text_type_basic tb">
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        readonly
                        class="ft-size12"
                        :value="item.priority_country_code"
                      >
                      </v-text-field>
                    </div>
                  </td>
                  <td>
                    <div class="input_text_type_basic tb">
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        readonly
                        class="ft-size12"
                      >
                      </v-text-field>
                    </div>
                  </td>
                  <td>
                    <div class="input_text_type_basic tb">
                      <v-text-field
                        dense
                        outlined
                        hide-details
                        readonly
                        class="ft-size12"
                      >
                      </v-text-field>
                    </div>
                  </td>
                </tr>
              </template>
            </table>
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0 bd-ddd bd-t0">
        <v-col cols="12" class="pb-0">
          <h2 class="nec_title">
            A certified copy of the following earlier application(s) is attached.مرفق صورة موثقة من طلب الاسبقية
          </h2>
        </v-col>
        <v-col cols="12" class="pt-0 d-flex align-center">
          <template v-for="(item, index) in priorities">
            <div :key="index">
              <v-checkbox
                class="ft-size12"
                hide-details
                readonly
                :label="'('+(index + 1)+')'"
                :input-value="item.priority_en_file_key || item.priority_ar_file_key"
              ></v-checkbox>
              <v-spacer style="width: 70px;"></v-spacer>
            </div>
          </template>
        </v-col>
        <v-col cols="12">
          <h2 class="nec_title small" style="line-height:20px;">*Where the earlier application is an ARIPO application, indicate at least one country party to the Paris Convention for the Protection of Industrial Property or one Member of the World Trade Organization for which that earlier application was filed :</h2>
          <h2 class="nec_title small mt--5"> فى حالة أن يكون مستند الاسبقية طلب إقليمى من الاريبو مثلا يجب ذكر دولة واحدة من الدول الاعضاء فى باريس أو منظمة التجارة العالمية فى السطر اللاحق</h2>
          <div class="input_text_type_basic mt--5">
            <v-text-field
              dense
              outlined
              hide-details
              readonly
              class="ft-size12"
            >
            </v-text-field>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Temporary protection -->
    <v-row>
      <v-col cols="12" class="pb-0">
        <h2 class="nec_title type2 small">(8) Temporary protection / الحماية المؤقتة</h2>
      </v-col>
      <v-col cols="12" class="pb-0 pt-0">
        <div class="table__inner__table wp100">
          <table>
            <tr>
              <td><v-col class="nec_title small">Country / أسم الدولة</v-col></td>
              <td><v-col class="nec_title small">Exhibition name / أسم المعرض</v-col></td>
              <td><v-col class="nec_title small">Exhibition opening Date<br/>تاريخ إفتتاح المعرض</v-col></td>
              <td><v-col class="nec_title small">Date of Protection<br/>تاريخ الحماية</v-col></td>
            </tr>
            <template v-for="(item, index) in temporaries">
              <tr :key="index">
                <td>
                  <div class="input_text_type_basic tb">
                    <v-select
                      hide-details
                      :items="countryList"
                      outlined
                      dense
                      readonly
                      :value="item.exhibition_country_code"
                      class="ft-size12"
                    ></v-select>
                  </div>
                </td>
                <td>
                  <div class="input_text_type_basic tb">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                      :value="item.exhibition_name_en"
                    >
                    </v-text-field>
                  </div>
                </td>
                <td>
                  <div class="input_text_type_basic tb">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                      :value="parseDateFormat(item.opening_date)"
                    >
                    </v-text-field>
                  </div>
                </td>
                <td>
                  <div class="input_text_type_basic tb">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                      :value="parseDateFormat(item.protection_date)"
                    >
                    </v-text-field>
                  </div>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </v-col>
    </v-row>

    <v-row class="ml-0 mr-0 mt-15">
      <v-col cols="12" class="bd-ddd bd-b0 pb-0">
        <v-checkbox
          class="ft-size12"
          hide-details
          readonly
          label="If the application according to Article (17) Please identify the relevant Ministry:"
        ></v-checkbox>
        <h2 class="nec_title ft-size12 text-right">طبقا للمادة (17)من القانون تعلق الطلب بإحدى الوزارة التالية برجاء تحديد الوزارة :</h2>
        <div class="d-flex align-center text-right">
          <v-checkbox
            class="ft-size12"
            hide-details
            readonly
            label="وزارة الدفاع"
          ></v-checkbox>
          <v-checkbox
            class="ft-size12"
            hide-details
            readonly
            label="وزارة الانتاج الجربي"
          ></v-checkbox>
          <v-checkbox
            class="ft-size12"
            hide-details
            readonly
            label="وزارة الدخلية"
          ></v-checkbox>
          <v-checkbox
            class="ft-size12"
            hide-details
            readonly
            label="وزاررة الصحة"
          ></v-checkbox>
        </div>
      </v-col>
      <v-col cols="12" class="bd-ddd">
        <h2 class="nec_title d-flex align-center">Did the application related to Micro-organizm Protection <v-spacer></v-spacer> هل الطلب متعلق بحماية كائنات دقيقة</h2>
        <div class="rtl">
          <v-checkbox
            class="ft-size12"
            hide-details
            readonly
            label="Yes / نعم"
            :input-value="filing.ind_micro_org_protection == 'Y'"
          ></v-checkbox>
        </div>
      </v-col>
    </v-row>

    <v-row class="ml-0 mr-0 bd-ddd mt-20 rtl__to__ltr">
      <v-col cols="12">
        <h2 class="nec_title small text-right">السيد الأستاذ / رئيس مكتب براءات الاختراع</h2>
      </v-col>
      <v-col cols="12" class="rtl">
        <h2 class="nec_title mt-25">الصادر بتاريخ</h2>
        <div class="align-center d-flex">
          <!-- 제출자가 applicant 인가 -->
          <v-checkbox
            class="ft-size12"
            hide-details
            readonly
            label="أنا الموقع على هذا بصفتى "
            :input-value="!is_agent"
          ></v-checkbox>
          <v-spacer class="hidden_lr5"></v-spacer>
          <!-- 제출자가 agent 인가 -->
          <v-checkbox
            class="ft-size12"
            hide-details
            readonly
            label="صاحب موضوع الطلب المقدم أو وكيلا عنه "
            :input-value="is_agent"
          ></v-checkbox>
          <v-spacer class="hidden_lr5"></v-spacer>
        </div>

        <h2 class="nec_title mt-35">بموجب التوكيل المقدم رقم</h2>

        <h2 class="nec_title mt-35">تحت مسمى : {{ filing.title_ar }}</h2>
        <div>
          <v-checkbox
            class="ft-size12"
            hide-details
            label="أطلب منحى براءة عن موضوع الطلب المبين بياناته أنفا  والمقدم للحصول على براءة إختراع "
            :input-value="filing.domain_sub_type_code === '2501' || filing.domain_type_code === '2401'"
          ></v-checkbox>
          <v-checkbox
            class="ft-size12"
            hide-details
            label="أو نموذج منفعة "
            :input-value="filing.domain_sub_type_code === '2502' && filing.domain_type_code === '2402'"
          ></v-checkbox>
        </div>

        <h2 class="nec_title mt-35" style="white-space:nowrap;">تحريرا فى</h2>
        <div><p>&nbsp;</p></div>
      </v-col>
    </v-row>

    <!-- 서명 이미지 -->
    <v-row class="ma-0 bd-ddd bd-t0">
      <v-col cols="12" class="d-flex rtl__to__ltr">
        <h2 class="nec_title">يا جيولي:و ب </h2>
        <v-spacer class="hidden_lr5"></v-spacer>
        <div class="input_text_type_basic sign_here">
          <v-img
            width="250px"
            height="100px"
            :src="signSrc"
            alt="Sign Here"
          ></v-img>
        </div>
      </v-col>
      <v-col cols="12" :class="$vuetify.rtl ? 'rtl__to__ltr' : ''">
        <div style="width: 100%;" v-show="!signSrc">
          <p style="font-size: 13px; margin-bottom: 0;">{{$t('user.signature.fields.msg1')}}</p>
          <p style="font-size: 13px;">{{$t('user.signature.fields.msg2')}}</p>
        </div>
        <div style="width: 100%;" v-show="!signSrc">
          <div>
            <v-radio-group
              row
              v-model="sign_image_type"
              class="mt--2"
            >
              <v-radio
                :label="$t('user.signature.fields.upload_signature')"
                value="file"
              />
              <v-radio
                :label="$t('user.signature.fields.draw_signature')"
                value="canvas"
              />
            </v-radio-group>
          </div>
          <div class="file_inpt mb-15" style="width: 400px;" v-show="sign_image_type === 'file'">
            <v-file-input
              solo
              outlined
              flat
              dense
              :prepend-icon="$t('common.common.select_file')"
              class="login_text_filed"
              @change="fnChangeSignFile"
              v-model="signFile"
              accept=".jpg,.gif,.png"
              clearable
              @click:clear="signFile = null"
            ></v-file-input>
          </div>
          <!-- 리사이즈를 위한 캔버스 -->
          <canvas id="resize-1" v-show="false" width="100" height="50"></canvas>
          <!-- 이미지 크기 체크 -->
          <img id="check_img" v-show="false" :src="img_src" @load="fnCheckSize"/>
        </div>

      </v-col>
    </v-row>

    <v-row class="ma-0 content_box_inner_inn bg_box_type2 bt_ty1">
      <v-col class="pa-25 cs_info">
        <p>101 Kasr Al-Aini St., Cairo, Egypt</p>
        <p>Tel : +202-27921291-27921274</p>
        <p>Fax : +202-27921272</p>
        <p>E-mail : patinfo@egypo.gov.eg</p>
      </v-col>
      <v-col class="pa-25 cs_info rtl">
        <p>101 ش القصر العينى – القاهرة – مصر </p>
        <p>تليفون :27921272 – 27921274 - 27921291-202+</p>
        <p>فاكس : 27921273 – 202+</p>
        <p>البريد الإلكترونى : patinfo@egypo.gov.eg </p>
      </v-col>
    </v-row>

    <!-- CONTINUATION APPLICANT -->
    <div v-show="applicants.length > 1">
      <v-row>
        <v-col cols="12" class="pb-0">
          <h2 class="nec_title type2 small">
            Continuation of  (2) FURTHER APPLICANT(S) فى حالة وجود مقدم طلب  واحد لا يستخدم ولا يرفق هذا النموذج <br/>
            If none of the following sub-boxes is used, this sheet should not be included in the request.فى حالة عدم استخدام النموذج لا يتم إرفاقه
          </h2>
        </v-col>
      </v-row>
      <template v-for="(applicant, index) in applicants">
        <div :key="index" v-if="index > 0">
          <v-row style="margin-top : 0; padding-top: 0;">
            <v-col cols="12" class="pb-0 pt-0">
              <v-row class="posr ma-0">
                <v-col cols="3" class="bd-ddd posa-r">
                  <h2 class="nec_title">Telephone No. / رقم التليفون</h2>
                  <v-spacer class="hidden_lr5"></v-spacer>
                  <p style="font-size: 12px; font-weight: normal;">
                    {{ applicant.telephone }}
                  </p>
                </v-col>
                <v-col cols="9" class="bd-ddd bd-b0">
                  <h2 class="nec_title">Name</h2>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                      :value="applicant.name_en"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="9" class="bd-ddd">
                  <h2 class="nec_title text-right">الاسم</h2>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12 text-right"
                      :value="applicant.name_ar"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-row class="posr ma-0">
                <v-col cols="3" class="bd-ddd bd-t0 posa-r">
                  <h2 class="nec_title">Facsimile No. / رقم الفاكس</h2>
                  <v-spacer class="hidden_lr5"></v-spacer>
                  <p style="font-size: 12px; font-weight: normal;">
                    {{ applicant.fax }}
                  </p>
                </v-col>
                <v-col cols="9" class="bd-ddd bd-t0 bd-b0">
                  <h2 class="nec_title">Nationality</h2>
                  <div class="input_text_type_basic mt--5">
                    <v-select
                      hide-details
                      :items="countryEnList"
                      :value="applicant.nationality_code"
                      outlined
                      dense
                      readonly
                      class="ft-size12"
                    ></v-select>
                  </div>
                </v-col>
                <v-col cols="9" class="bd-ddd text-right">
                  <h2 class="nec_title">الجنسية</h2>
                  <div class="input_text_type_basic mt--5">
                    <v-select
                      hide-details
                      :items="countryArList"
                      :value="applicant.nationality_code"
                      outlined
                      dense
                      readonly
                      class="ft-size12"
                    ></v-select>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-row class="posr ma-0">
                <v-col cols="3" class="bd-ddd bd-t0 posa-r">
                  <h2 class="nec_title">E-mail address / البريد الالكترونى</h2>
                  <v-spacer class="hidden_lr5"></v-spacer>
                  <p style="font-size: 12px; font-weight: normal;">
                    {{ applicant.email }}
                  </p>
                </v-col>
                <v-col cols="9" class="bd-ddd bd-t0 bd-b0">
                  <h2 class="nec_title">Resident Address</h2>
                  <v-row>
                    <v-col>
                      <label class="nec_title">Country : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-select
                          hide-details
                          :items="countryEnList"
                          :value="applicant.residence_country_code"
                          outlined
                          dense
                          readonly
                          class="ft-size12"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col>
                      <label class="nec_title">City : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <label class="nec_title">Address : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="applicant.address_en"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <label class="nec_title">P.O. Box : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="applicant.pobox_en"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="9" class="bd-ddd">
                  <h2 class="nec_title text-right">العنوان البريدى</h2>
                  <v-row class="rtl">
                    <v-col>
                      <label class="nec_title">الدولة : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-select
                          hide-details
                          :items="countryArList"
                          :value="applicant.residence_country_code"
                          outlined
                          dense
                          readonly
                          class="ft-size12"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col>
                      <label class="nec_title">المدينة : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="rtl">
                    <v-col>
                      <label class="nec_title">العنوان : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="applicant.address_ar"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="rtl">
                    <v-col>
                      <label class="nec_title">ص . ب : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="applicant.pobox_ar"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="bd-ddd ma-0 bd-t0" style="margin-bottom: 10px !important;">
            <v-col>
              <h2 class="nec_title">State (that is, country) of nationality: دولة الجنسية</h2>
              <div class="input_text_type_basic mt--5">
                <v-select
                  hide-details
                  :items="countryList"
                  v-model="applicant.nationality_code"
                  outlined
                  dense
                  readonly
                  class="ft-size12"
                ></v-select>
              </div>
            </v-col>
            <v-col class="bd-ddd bd-t0 bd-b0">
              <h2 class="nec_title">State (that is, country) of residence: دولة الإقامة</h2>
              <div class="input_text_type_basic mt--5">
                <v-select
                  hide-details
                  :items="countryList"
                  v-model="applicant.residence_country_code"
                  outlined
                  dense
                  readonly
                  class="ft-size12"
                ></v-select>
              </div>
            </v-col>
          </v-row>
        </div>
      </template>
    </div>

    <!-- CONTINUATION INVENTOR -->
    <div v-show="inventors.length > 1">
      <v-row>
        <v-col cols="12" class="pb-0">
          <h2 class="nec_title type2 small">
            Continuation of  (3) FURTHER INVENTOR(S) فى حالة وجود مقدم طلب  واحد لا يستخدم ولا يرفق هذا النموذج <br/>
            If none of the following sub-boxes is used, this sheet should not be included in the request.فى حالة عدم استخدام النموذج لا يتم إرفاقه
          </h2>
        </v-col>
      </v-row>
      <template v-for="(inventor,index) in inventors">
        <div :key="index" v-if="index > 0">
          <v-row style="margin-top : 0; padding-top: 0;">
            <v-col cols="12" class="pb-0 pt-0">
              <v-row class="posr ma-0">
                <v-col cols="3" class="bd-ddd posa-r">
                  <h2 class="nec_title">Telephone No. / رقم التليفون</h2>
                  <v-spacer class="hidden_lr5"></v-spacer>
                  <p style="font-size: 12px; font-weight: normal;">
                    {{ inventor.telephone }}
                  </p>
                </v-col>
                <v-col cols="9" class="bd-ddd bd-b0">
                  <h2 class="nec_title">Name</h2>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                      :value="inventor.name_en"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="9" class="bd-ddd">
                  <h2 class="nec_title text-right">الاسم</h2>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12 text-right"
                      :value="inventor.name_ar"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-row class="posr ma-0">
                <v-col cols="3" class="bd-ddd bd-t0 posa-r">
                  <h2 class="nec_title">Facsimile No. / رقم الفاكس</h2>
                  <v-spacer class="hidden_lr5"></v-spacer>
                  <p style="font-size: 12px; font-weight: normal;">
                    {{ inventor.fax }}
                  </p>
                </v-col>
                <v-col cols="9" class="bd-ddd bd-t0 bd-b0">
                  <h2 class="nec_title">Nationality</h2>
                  <div class="input_text_type_basic mt--5">
                    <v-select
                      hide-details
                      :items="countryEnList"
                      outlined
                      dense
                      readonly
                      class="ft-size12"
                      :value="inventor.nationality_code"
                    ></v-select>
                  </div>
                </v-col>
                <v-col cols="9" class="bd-ddd text-right">
                  <h2 class="nec_title">الجنسية</h2>
                  <div class="input_text_type_basic mt--5">
                    <v-select
                      hide-details
                      :items="countryArList"
                      outlined
                      dense
                      readonly
                      class="ft-size12"
                      :value="inventor.nationality_code"
                    ></v-select>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-row class="posr ma-0">
                <v-col cols="3" class="bd-ddd bd-t0 posa-r">
                  <h2 class="nec_title">E-mail address / البريد الالكترونى</h2>
                  <v-spacer class="hidden_lr5"></v-spacer>
                  <p style="font-size: 12px; font-weight: normal;">
                    {{ inventor.email }}
                  </p>
                </v-col>
                <v-col cols="9" class="bd-ddd bd-t0 bd-b0">
                  <h2 class="nec_title">Resident Address</h2>
                  <v-row>
                    <v-col>
                      <label class="nec_title">Country : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-select
                          hide-details
                          :items="countryEnList"
                          outlined
                          dense
                          readonly
                          class="ft-size12"
                          :value="inventor.nationality_code"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col>
                      <label class="nec_title">City : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <label class="nec_title">Address : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="inventor.address_en"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <label class="nec_title">P.O. Box : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="inventor.pobox_en"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="9" class="bd-ddd">
                  <h2 class="nec_title text-right">العنوان البريدى</h2>
                  <v-row class="rtl">
                    <v-col>
                      <label class="nec_title">الدولة : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-select
                          hide-details
                          :items="countryArList"
                          outlined
                          dense
                          readonly
                          class="ft-size12"
                          :value="inventor.nationality_code"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col>
                      <label class="nec_title">المدينة : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="rtl">
                    <v-col>
                      <label class="nec_title">العنوان : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="inventor.address_ar"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="rtl">
                    <v-col>
                      <label class="nec_title">ص . ب : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="inventor.pobox_ar"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>

      </template>
    </div>

    <!-- CONTINUATION REPRESENTATIVE -->
    <div v-show="representatives.length > 1">
      <v-row>
        <v-col cols="12" class="pb-0">
          <h2 class="nec_title type2 small">Continuation of (4) REPRESENTATIVE:  The person identified below is hereby/has been appointed to act on behalf of the applicant(s)<br/>before the Office as a representative     (بيانات الوكيل)    الشخص التالى أسمه تم تعينه من قبل مقدم / مقدمى الطلب لتمثيل / تمثيلهم  أمام المكتب
          </h2>
        </v-col>
      </v-row>
      <template v-for="(representative, index) in representatives ">
        <div :key="index" v-if="index > 0">
          <v-row>
            <v-col cols="12" class="pt-0 pb-0">
              <v-row class="posr ma-0">
                <v-col cols="3" class="bd-ddd bd-b0 posa-r">
                  <h2 class="nec_title">Telephone No. / رقم التليفون</h2>
                  <v-spacer class="hidden_lr5"></v-spacer>
                  <p style="font-size: 12px; font-weight: normal;">
                    {{ representative.telephone }}
                  </p>
                </v-col>
                <v-col cols="9" class="bd-ddd bd-b0">
                  <h2 class="nec_title">Name</h2>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12"
                      :value="representative.name_en"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-row class="posr ma-0">
                <v-col cols="3" class="bd-ddd posa-r">
                  <h2 class="nec_title">Facsimile No. / رقم الفاكس</h2>
                  <v-spacer class="hidden_lr5"></v-spacer>
                  <p style="font-size: 12px; font-weight: normal;">
                    {{ representative.fax }}
                  </p>
                </v-col>
                <v-col cols="9" class="bd-ddd">
                  <h2 class="nec_title text-right">الاسم</h2>
                  <div class="input_text_type_basic mt--5">
                    <v-text-field
                      dense
                      outlined
                      hide-details
                      readonly
                      class="ft-size12 text-right"
                      :value="representative.name_ar"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-row class="posr ma-0">
                <v-col cols="3" class="bd-ddd bd-t0 bd-b0 posa-r">
                  <h2 class="nec_title">E-mail address / البريد الالكترونى</h2>
                  <v-spacer class="hidden_lr5"></v-spacer>
                  <p style="font-size: 12px; font-weight: normal;">
                    {{ representative.email }}
                  </p>
                </v-col>
                <v-col cols="9" class="bd-ddd bd-t0 bd-b0">
                  <h2 class="nec_title">Address</h2>
                  <v-row>
                    <v-col>
                      <label class="nec_title">Country : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-select
                          hide-details
                          :items="countryEnList"
                          outlined
                          dense
                          readonly
                          class="ft-size12"
                          :value="representative.nationality_code"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col>
                      <label class="nec_title">City : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <label class="nec_title">Address : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="representative.address_en"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <label class="nec_title">P.O. Box : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="representative.pobox_en"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="posr ma-0">
                <v-col cols="3" class="bd-ddd posa-r">
                  <h2 class="nec_title">Registration No. رقم التسجيل</h2>
                  <v-spacer class="hidden_lr5"></v-spacer>
                  <p style="font-size: 12px; font-weight: normal;">
                    {{ representative.agent_no }}
                  </p>
                </v-col>
                <v-col cols="9" class="bd-ddd">
                  <h2 class="nec_title text-right">العنوان البريدى</h2>
                  <v-row class="rtl">
                    <v-col>
                      <label class="nec_title">الدولة : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-select
                          hide-details
                          :items="countryArList"
                          outlined
                          dense
                          readonly
                          class="ft-size12"
                          :value="representative.nationality_code"
                        ></v-select>
                      </div>
                    </v-col>
                    <v-col>
                      <label class="nec_title">المدينة : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="rtl">
                    <v-col>
                      <label class="nec_title">العنوان : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="representative.address_ar"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="rtl">
                    <v-col>
                      <label class="nec_title">ص . ب : </label>
                      <div class="input_text_type_basic mt--5">
                        <v-text-field
                          dense
                          outlined
                          hide-details
                          readonly
                          class="ft-size12"
                          :value="representative.pobox_ar"
                        >
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="ma-0 bd-ddd bd-t0">
                <v-col cols="12">
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    label="The person above represents all applicants./ المذكور أعلاه يمثل كل المقدمين"
                    class="mt-0 ft-size12"
                    :input-value="representative.rep_scope_type_code == '5101'"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    label="If not, specify the applicant(s) who is(are) represented by the person above:/ لو غير ذلك يذكر أسم مقدم الطلب الذى يمثله المذكور أعلاه" class="mt-0 ft-size12"
                    :input-value="representative.rep_scope_type_code == '5102'"
                  ></v-checkbox>
                  <span class="pl-30" v-if="representative.applicants.length > 0">
                    <template v-for="(applicant, index) in representative.applicants">
                      <span v-if="index > 0" :key="'r_comma'+ index">, </span>
                      <span class="ft-size12" :key="'r_name'+ index">{{applicant.name_ar}}</span>
                    </template>
                  </span>
                </v-col>
              </v-row>
              <v-row class="ma-0 bd-ddd bd-t0">
                <v-col cols="12">
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    label="The power of attorney is attachedمرفق التوكيل"
                    class="mt-0 ft-size12"
                    :input-value="JSON.stringify(representative.poa_upload_type_codes).indexOf('5201') > -1"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    label="The appointment is made in this request Formالتعيين طبقا للطلب المرفق"
                    class="mt-0 ft-size12"
                    :input-value="JSON.stringify(representative.poa_upload_type_codes).indexOf('5202') > -1"
                  ></v-checkbox>
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    :label="'The power of attorney (No. '+ (JSON.stringify(representative.poa_upload_type_codes).indexOf('5203') > -1 ? representative.poa_reference_app_no : '.....................') +')    is already in the possession of the Office. التوكيل موجود بالمكتب'"
                    class="mt-0 ft-size12"
                    :input-value="JSON.stringify(representative.poa_upload_type_codes).indexOf('5203') > -1"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </template>
    </div>

    <Signature ref="signature" @success="fnSetSignImage" />
  </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import Signature from '@/views/user/Signature.vue'

export default {
  props : {
    receipt_no: String
  },
  components : {
    Signature
  },
  data() {
    return {
      // 사인
      sign_image_type : 'file',
      img_src : '',


      is_agent : false,
      utility_chk : true,
      patent_chk : false,
      countryEnList : [],
      countryArList : [],
      countryList : [],
      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',
      signSrc : '',
      signFile : null,
      sign_file_key : '',
      user_group_type_code: '',

      filing : {
        seq : '',
        application_no: '',
        filing_date: '',
        filing_time: '',
        receipt_seq : '',
        domain_type_code : '',
        domain_sub_type_code : '',
        title_ar : '',
        title_en : '',
        abstract_ar : '',
        ind_abs_translation_ar : '',
        abstract_en : '',
        ind_abs_translation_en : '',
        function_ar : '',
        ind_fnc_translation_ar : '',
        function_en : '',
        ind_fnc_translation_en : '',
        exhibition_country_code : '',
        exhibition_name_ar : '',
        exhibition_name_en : '',
        opening_date : '',
        end_date : '',
        ind_drawing_confirm : '',
        ind_review_confirm : '',
        ind_front_page_confirm : '',
        ind_missing_doc_confirm : '',
        ind_attached_document : '',
        international_application_no : '',
        international_filing_date : '',
        pct_publication_no : '',
        pct_publication_date : '',
        ind_micro_org_protection : '',
        micro_org_file_key : '',
        ind_request_pph : '',
        pph_doc_file_key : '',
        sign_image: '',

        orginal_application : {
          filing_date : '',
          application_no : '',
          application_type_code: '',
          title_ar : '',
          itle_en : '',
          ind_divisional_app : '',
          ind_divisional_patent: '',
          ind_divisional_um: '',
          ind_earlier_app : '',
          ipas_file_seq : '',
          ipas_file_typ : '',
          ipas_file_ser : '',
          ipas_file_nbr : ''
        }
      },

      applicants : [],
      inventors : [],
      representatives : [],
      correspondences : [],
      priorities : [],
      temporaries : [],

      applicant_first : {
        seq : '',
        filing_seq: '',
        applicant_type_code: '',
        nationality_code: '',
        residence_country_code: '',
        name_ar: '',
        name_en: '',
        address_ar: '',
        address_en: '',
        pobox_ar: '',
        pobox_en: '',
        birthday_date: '',
        gender_type_code: '',
        telephone: '',
        mobile: '',
        fax: '',
        email: '',
        id_card_file_key: '',
        id_card_file_name: '',
        ind_representative: '',
        ind_inventor: '',
        representative_seq: ''
      },

      inventor_first : {
        seq : '',
        filing_seq : '',
        nationality_code : '',
        residence_country_code : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        pobox_ar : '',
        pobox_en : '',
        birthday_date : '',
        gender_type_code : '',
        telephone : '',
        mobile : '',
        fax : '',
        email : '',
        applicant_seq : ''
      },

      representative_first : {
        seq : '',
        filing_seq : '',
        nationality_code : '',
        residence_country_code : '',
        name_ar : '',
        name_en : '',
        address_ar : '',
        address_en : '',
        pobox_ar : '',
        pobox_en : '',
        telephone : '',
        mobile : '',
        fax : '',
        email : '',
        agent_no : '',
        rep_scope_type_code : '',
        poa_upload_type_codes : [],
        poa_reference_app_no : '',
        poa_file_key : '',
        poa_file_name : '',
        applicants : [{ seq : '' }]
      },


      prioritie_first : {},
      temporarie_first : {},

      poa_number : '..........................'



    }
  },
  watch : {
    // 사인
    sign_image_type(val){
      if(val == 'canvas'){
        this.$refs.signature.dialog_sign = true
      }
    },
  },
  mounted(){
    this.fnGetCountryList()
    this.fnGetFilingData()
    this.fnGetApplicants()
    this.fnGetInventors()
    this.fnGetRepresentatives()
    this.fnGetPriorities()
    this.fnGetTemporaries()
  },
  methods: {
    parseDateFormat(str){
      if(str){
        let splitStr = str
        if(str.indexOf('-') > -1){
          splitStr = str.split("-").join("/")
        }
        return splitStr
      }
    },
    // 사인
    fnSetSignImage(imgStr){
      this.signSrc = ''
      this.signSrc = imgStr

      let params = { sign_image : this.signSrc }
      requestApi({
        url: '/users/profile/sign',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.modify.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
            this.fnGetProfile()
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSetSignImage(imgStr)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

    },
    fnChangeSignFile(){
      if(this.signFile){
        let file = this.signFile

        let extList = []
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})
        extList.push({name_en: 'png'})

        if (utils.getFileExtLen(file, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.signFile = null
          }, 100)

          return
        }

        this.img_src = URL.createObjectURL(file)
      }
    },
    fnCheckSize(){
      let img = document.getElementById('check_img')
      let width = img.naturalWidth
      let height = img.naturalHeight

      if(width > 100 || height > 50){
        eventBus.$emit('SHOW_SNACKBAR', { text : this.$t('user.signature.fields.upload_signature') })
        this.signFile = null
        this.img_src = ''
      }else{
        let resize = document.getElementById('resize-1')
        let resizeCtx = resize.getContext('2d')
        resizeCtx.drawImage(img, 0, 0, width, height)
        let resizeSrc = resize.toDataURL('image/jpg')
        this.signSrc = ''
        this.signSrc = resizeSrc

        let params = { sign_image : this.signSrc }
        requestApi({
          url: '/users/profile/sign',
          method: 'PUT',
          data: params,
          callback: (res) => {
            if (res.res_code === '200') {
              let snackBarOptions = {
                text: this.$t('common.message.modify.success')
              }
              eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
              this.img_src = ''
            } else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnCheckSize()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },

    fnGetFilingData(){
      requestApi({
        url: '/receivings/utility/'+this.receipt_no+'/filing',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.filing.seq = res.data.seq
            this.filing.application_no = res.data.application_no
            this.filing.filing_date = res.data.filing_date
            this.filing.filing_time = res.data.filing_time
            this.filing.receipt_seq = res.data.receipt_seq
            this.filing.domain_type_code = res.data.domain_type_code
            this.filing.domain_sub_type_code = res.data.domain_sub_type_code
            this.filing.title_ar = res.data.title_ar
            this.filing.title_en = res.data.title_en
            this.filing.abstract_ar = res.data.abstract_ar
            this.filing.ind_abs_translation_ar = res.data.ind_abs_translation_ar
            this.filing.abstract_en = res.data.abstract_en
            this.filing.ind_abs_translation_en = res.data.ind_abs_translation_en
            this.filing.function_ar = res.data.function_ar
            this.filing.ind_fnc_translation_ar = res.data.ind_fnc_translation_ar
            this.filing.function_en = res.data.function_en
            this.filing.ind_fnc_translation_en = res.data.ind_fnc_translation_en
            this.filing.exhibition_country_code = res.data.exhibition_country_code
            this.filing.exhibition_name_ar = res.data.exhibition_name_ar
            this.filing.exhibition_name_en = res.data.exhibition_name_en
            this.filing.opening_date = res.data.opening_date
            this.filing.end_date = res.data.end_date
            this.filing.ind_drawing_confirm = res.data.ind_drawing_confirm
            this.filing.ind_review_confirm = res.data.ind_review_confirm
            this.filing.ind_front_page_confirm = res.data.ind_front_page_confirm
            this.filing.ind_missing_doc_confirm = res.data.ind_missing_doc_confirm
            this.filing.ind_attached_document = res.data.ind_attached_document
            this.filing.international_application_no = res.data.international_application_no
            this.filing.international_filing_date = res.data.international_filing_date.replace(/-/gi, '/')
            this.filing.pct_publication_no = res.data.pct_publication_no
            this.filing.pct_publication_date = res.data.pct_publication_date
            this.filing.ind_micro_org_protection = res.data.ind_micro_org_protection
            this.filing.micro_org_file_key = res.data.micro_org_file_key
            this.filing.ind_request_pph = res.data.ind_request_pph
            this.filing.pph_doc_file_key = res.data.pph_doc_file_key
            this.filing.sign_image = res.data.sign_image
            this.signSrc = this.filing.sign_image
            // 서명 이미지가 없을 경우에만 Profile 에서 서명이미지를 조회해서 넣는다
            if (utils.isNull(this.signSrc)) {
              this.fnGetProfile()
            } else {
              this.$emit('success', this.signSrc)
            }

            this.filing.orginal_application.filing_date = res.data.orginal_application.filing_date
            this.filing.orginal_application.application_no = res.data.orginal_application.application_no
            this.filing.orginal_application.application_type_code = res.data.orginal_application.application_type_code
            this.filing.orginal_application.title_ar = res.data.orginal_application.title_ar
            this.filing.orginal_application.itle_en = res.data.orginal_application.itle_en
            this.filing.orginal_application.ind_divisional_app = res.data.orginal_application.ind_divisional_app
            this.filing.orginal_application.ind_earlier_app = res.data.orginal_application.ind_earlier_app
            this.filing.orginal_application.ipas_file_seq = res.data.orginal_application.ipas_file_seq
            this.filing.orginal_application.ipas_file_typ = res.data.orginal_application.ipas_file_typ
            this.filing.orginal_application.ipas_file_ser = res.data.orginal_application.ipas_file_ser
            this.filing.orginal_application.ipas_file_nbr = res.data.orginal_application.ipas_file_nbr

            this.filing.orginal_application.ind_divisional_patent = 'N'
            this.filing.orginal_application.ind_divisional_um = 'N'
            if (this.filing.orginal_application.ind_divisional_app === 'Y') {
              if (this.filing.orginal_application.application_type_code === '8911' || this.filing.orginal_application.application_type_code === '8915') {
                this.filing.orginal_application.ind_divisional_patent = 'Y'
              } else if (this.filing.orginal_application.application_type_code === '8912') {
                this.filing.orginal_application.ind_divisional_um = 'Y'
              }
            }

            this.user_group_type_code = res.data.user_group_type_code

            //제출자가 agent인가 여부
            if(this.user_group_type_code == '3803' || this.user_group_type_code == '3804'){
              this.is_agent = true

            } else {
              this.is_agent = false
            }

          } else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetFilingData()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetApplicants(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/applicants',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.applicants = res.data.list

            if(res.data.list.length > 0){
              this.applicant_first.seq = res.data.list[0].seq
              this.applicant_first.filing_seq = res.data.list[0].filing_seq
              this.applicant_first.applicant_type_code = res.data.list[0].applicant_type_code
              this.applicant_first.nationality_code = res.data.list[0].nationality_code
              this.applicant_first.residence_country_code = res.data.list[0].residence_country_code
              this.applicant_first.name_ar = res.data.list[0].name_ar
              this.applicant_first.name_en = res.data.list[0].name_en
              this.applicant_first.address_ar = res.data.list[0].address_ar
              this.applicant_first.address_en = res.data.list[0].address_en
              this.applicant_first.pobox_ar = res.data.list[0].pobox_ar
              this.applicant_first.pobox_en = res.data.list[0].pobox_en
              this.applicant_first.birthday_date = res.data.list[0].birthday_date
              this.applicant_first.gender_type_code = res.data.list[0].gender_type_code
              this.applicant_first.telephone = res.data.list[0].telephone
              this.applicant_first.mobile = res.data.list[0].mobile
              this.applicant_first.fax = res.data.list[0].fax
              this.applicant_first.email = res.data.list[0].email
              this.applicant_first.id_card_file_key = res.data.list[0].id_card_file_key
              this.applicant_first.id_card_file_name = res.data.list[0].id_card_file_name
              this.applicant_first.ind_representative = res.data.list[0].ind_representative
              this.applicant_first.ind_inventor = res.data.list[0].ind_inventor
              this.applicant_first.representative_seq = res.data.list[0].representative_seq
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicants()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetInventors(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/inventors',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.inventors = res.data.list

            if(res.data.list.length > 0){
              this.inventor_first.seq = res.data.list[0].seq
              this.inventor_first.filing_seq = res.data.list[0].filing_seq
              this.inventor_first.nationality_code = res.data.list[0].nationality_code
              this.inventor_first.residence_country_code = res.data.list[0].residence_country_code
              this.inventor_first.name_ar = res.data.list[0].name_ar
              this.inventor_first.name_en = res.data.list[0].name_en
              this.inventor_first.address_ar = res.data.list[0].address_ar
              this.inventor_first.address_en = res.data.list[0].address_en
              this.inventor_first.pobox_ar = res.data.list[0].pobox_ar
              this.inventor_first.pobox_en = res.data.list[0].pobox_en
              this.inventor_first.birthday_date = res.data.list[0].birthday_date
              this.inventor_first.gender_type_code = res.data.list[0].gender_type_code
              this.inventor_first.telephone = res.data.list[0].telephone
              this.inventor_first.mobile = res.data.list[0].mobile
              this.inventor_first.fax = res.data.list[0].fax
              this.inventor_first.email = res.data.list[0].email
              this.inventor_first.applicant_seq = res.data.list[0].applicant_seq
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetInventors()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetRepresentatives(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/representatives',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.representatives = res.data.list
            if(res.data.list.length > 0){
              this.representative_first.seq = res.data.list[0].seq
              this.representative_first.filing_seq = res.data.list[0].filing_seq
              this.representative_first.nationality_code = res.data.list[0].nationality_code
              this.representative_first.name_ar = res.data.list[0].name_ar
              this.representative_first.name_en = res.data.list[0].name_en
              this.representative_first.address_ar = res.data.list[0].address_ar
              this.representative_first.address_en = res.data.list[0].address_en
              this.representative_first.pobox_ar = res.data.list[0].pobox_ar
              this.representative_first.pobox_en = res.data.list[0].pobox_en
              this.representative_first.telephone = res.data.list[0].telephone
              this.representative_first.mobile = res.data.list[0].mobile
              this.representative_first.fax = res.data.list[0].fax
              this.representative_first.email = res.data.list[0].email
              this.representative_first.agent_no = res.data.list[0].agent_no
              this.representative_first.rep_scope_type_code = res.data.list[0].rep_scope_type_code
              this.representative_first.poa_upload_type_codes = res.data.list[0].poa_upload_type_codes
              this.representative_first.poa_reference_app_no = res.data.list[0].poa_reference_app_no
              this.representative_first.poa_file_key = res.data.list[0].poa_file_key
              this.representative_first.poa_file_name = res.data.list[0].poa_file_name
              this.representative_first.applicants = res.data.list[0].applicants
              this.representative_first.residence_country_code = res.data.list[0].nationality_code //나중에 추가될 예정인데 일단 국적코드로 갈음 해둠

              if (this.representative_first.poa_upload_type_codes.length === 0 && res.data.list[0].poa_upload_type_code) {
                this.representative_first.poa_upload_type_codes.push(res.data.list[0].poa_upload_type_code)
              }

              this.representatives.forEach(item => {
                if (item.poa_upload_type_codes.length === 0 && item.poa_upload_type_code) {
                  item.poa_upload_type_codes.push(item.poa_upload_type_code)
                }
              })
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetRepresentatives()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetCorrespondences(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/correspondences',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.correspondences = res.data.list
            if(res.data.list.length > 0){
              this.correspondence_first.seq = res.data.list[0].seq
              this.correspondence_first.filing_seq = res.data.list[0].filing_seq
              this.correspondence_first.nationality_code = res.data.list[0].nationality_code
              this.correspondence_first.residence_country_code = res.data.list[0].residence_country_code
              this.correspondence_first.name_ar = res.data.list[0].name_ar
              this.correspondence_first.name_en = res.data.list[0].name_en
              this.correspondence_first.address_ar = res.data.list[0].address_ar
              this.correspondence_first.address_en = res.data.list[0].address_en
              this.correspondence_first.pobox_ar = res.data.list[0].pobox_ar
              this.correspondence_first.pobox_en = res.data.list[0].pobox_en
              this.correspondence_first.telephone = res.data.list[0].telephone
              this.correspondence_first.mobile = res.data.list[0].mobile
              this.correspondence_first.fax = res.data.list[0].fax
              this.correspondence_first.email = res.data.list[0].email
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetCorrespondences()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetPriorities() {
      requestApi({
        url: '/receivings/'+this.receipt_no+'/priorities',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.priorities = res.data.list
            let cnt = res.data.list.length

            //기본 4개까지는 보여줘야 한다
            if(cnt < 4){
              for(let i=cnt; i<4; i++){
                let emptyItem = {}
                this.priorities.push(emptyItem)
              }
            }

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPriorities()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetTemporaries(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/temporaries',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.temporaries = res.data.list
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetTemporaries()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetCountryList() {
      //국가 정보를 가져온다
      utils.fnGetCountryList('en').then(list => {
        this.countryEnList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      utils.fnGetCountryList('ar').then(list => {
        this.countryArList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      utils.fnGetCountryList().then(list => {
        this.countryList = list
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })
    },

    fnParseApplicantTypeCode(applicant_type_code){

      let result = ''

      if(applicant_type_code == '2701'){
        result = 'Company'
      }else if(applicant_type_code == '2702'){
        result = 'Company'
      }else if(applicant_type_code == '2703'){
        result = 'Research'
      }else if(applicant_type_code == '2704'){
        result = 'Individual'
      }else if(applicant_type_code == '2705'){
        result = 'Individual'
      }else if(applicant_type_code == '2706'){
        result = 'Research'
      }

      return result
    },

    fnGetProfile(){
      requestApi({
        url: '/users/profile',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data.representative_sign_image){
              this.signSrc = res.data.representative_sign_image
              //부모창으로 사인파일키를 전송
              this.$emit('success', res.data.representative_sign_image)
            }
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetProfile()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }

  }
}
</script>